// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__X02md","loader":"Loader_loader__+lRPl","spin":"Loader_spin__E4RJ0"};